import { render, staticRenderFns } from "./refund-ticket.vue?vue&type=template&id=a08e1dc6&scoped=true&"
import script from "./refund-ticket.vue?vue&type=script&lang=js&"
export * from "./refund-ticket.vue?vue&type=script&lang=js&"
import style0 from "./refund-ticket.vue?vue&type=style&index=0&id=a08e1dc6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a08e1dc6",
  null
  
)

export default component.exports